import countriesJson from '@/resources/countries.json';

const getDefaultState = () => {
    return {
        locale: null,
        cmsLocaleKey: null,
        isUSA: process.env.VUE_APP_COUNTRY_ISO === 'USA',
        isDEU: process.env.VUE_APP_COUNTRY_ISO === 'DEU',
        isNLD: process.env.VUE_APP_COUNTRY_ISO === 'NLD',
        isAUT: process.env.VUE_APP_COUNTRY_ISO === 'AUT',
        country: process.env.VUE_APP_COUNTRY_ISO,
        currency: countriesJson.find(country => country.iso === process.env.VUE_APP_COUNTRY_ISO).currency.symbol,
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },

        setLocale(state, payload) {
            state.locale = payload;
        },

        setCmsLocaleKey(state, payload) {
            state.cmsLocaleKey = payload;
        },
    },
    actions: {
        resetLocale({ commit }) {
            commit('resetState');
        },
    },
    getters: {
        getSelectedLocale: state => state.locale,

        getCmsLocaleKey: state => state.cmsLocaleKey,

        enableKareWidget: state => state.isDEU,

        isUSA: state => state.isUSA,

        isDEU: state => state.isDEU,

        isNLD: state => state.isNLD,

        isAUT: state => state.isAUT,

        getCurrency: state => state.currency,

        country: state => state.country,
    },
};
